export { MotExpired as default } from "./MotExpired";
